






























import { Component, Vue, Prop } from "vue-property-decorator";
import { FocusedTask, ScheduledTask } from "@/data/models/Task";
import { ButtonState } from "@/components/common/StateButton.vue";
import { SchedulingModule } from "@/store/modules/SchedulingModule";
import { COLOR_SCHEDULING_CHECKBOX } from "@/utils/colors";

@Component
export default class ScheduledTaskFormComponent extends Vue {
  @Prop()
  scheduledTask!: ScheduledTask;

  @Prop()
  editEnabled!: boolean;

  @Prop()
  focusedTask!: FocusedTask;

  get buttonState() {
    return this.editEnabled ? ButtonState.RED : ButtonState.DISABLED;
  }

  checkBoxColor = COLOR_SCHEDULING_CHECKBOX;

  wasAddNoteButtonClicked = false;

  get showNote() {
    return this.focusedTask?.showNote ?? false;
  }

  get noteButtonText() {
    return this.showNote
      ? this.$t("scheduling.taskDetails.deleteNote")
      : this.$t("scheduling.taskDetails.addNote");
  }

  onNoteButtonClicked() {
    if (this.showNote) {
      SchedulingModule.updateFocusedTask({
        id: this.focusedTask.id,
        showNote: false,
      });
      this.$emit("noteChanged", null);
    } else {
      SchedulingModule.updateFocusedTask({
        id: this.focusedTask.id,
        showNote: true,
      });
    }
  }

  get taskConfirmed() {
    return this.scheduledTask.wasConfirmed;
  }

  set taskConfirmed(value: boolean) {
    this.$emit("taskConfirmedChanged", value);
  }
}
